/**
 *  Align cells within the carousel element.
 *  "left", "center", "right"
 */
var CellAlign;
(function (CellAlign) {
    CellAlign["left"] = "left";
    CellAlign["center"] = "center";
    CellAlign["right"] = "right";
})(CellAlign || (CellAlign = {}));
/**
 *  CAROUSEL CONFIG
 *  Configuration object to create the slider:
 *
 *  @param {string} sliderSelector - querySelector of carousel. Choose [data-carousel] if you want to select all carousel.
 *  @param {CellAlign} cellAlign - Align cells within the carousel element. Choose "left", "center", "right".
 *  @param {boolean} contain - Contains cells to carousel element to prevent excess scroll at beginning or end. Has no effect if wrapAround: true
 *  @param {boolean | number} autoPlay - Automatically advances to the next cell.
 *  @param {boolean} wrapAround - At the end of cells, wrap-around to the other end for infinite scrolling.
 *  @param {boolean} showArrows - Display or not the built-in arrows of the carousel.
 *  @param {boolean} showDots - Display or not the built-in dots of the carousel.
 *  @param {boolean} groupCells - Groups cells together in slides. Flicking, page dots, and previous/next buttons are mapped to group slides, not individual cells. is-selected class is added to the multiple cells in the selected slide.
 *  @param {boolean} adaptiveHeight - Changes the slider's height based on slide's height
 *  @param {boolean} imagesLoaded - Unloaded images have no size, which can throw off cell positions. To fix this, the imagesLoaded option re-positions cells once their images have loaded.
 *  @param {number} viewport - An optional parameter to decide at which viewport the carousel should be activated
 *  @param {number} destroyViewport - An optional parameter to decide at which viewport the carousel should be destroyed.
 *  @param {boolean} activateCustomButtons - An optional parameter to activate custom buttons
 *  @param {boolean} notDraggable - An optional parameter to remove drag behaviour
 *  @param {boolean} fullscreen - Toggles fullscreen
 *  @param {boolean} sameCardHeight - An optional parameter to set all the items with the same height. (Could be better: https://github.com/metafizzy/flickity/issues/534)
 *  @param {boolean} horizontalScrolling - An optional parameter to set the horizontal scrolling of the carousel insted of scrolling the page.
 *  @param {boolean} sliderT8 - An optional parameter to activate only for Slider Heading Typology-8
 */
class CarouselConfig {
}
class ResponsiveCarousel {
    constructor() {
        /**
         *  CREATE CAROUSEL
         *
         *  Here are all the configurations to create the Flickity slider.
         */
        this.createCarousel = (carousel, config) => {
            if (carousel && config) {
                return new Flickity(carousel, {
                    on: {
                        ready: function () {
                            carousel.setAttribute("data-carousel", "active");
                        }
                    },
                    //slider options
                    cellAlign: config.cellAlign.toString(),
                    contain: config.contain,
                    autoPlay: config.autoPlay,
                    wrapAround: config.wrapAround,
                    prevNextButtons: config.showArrows,
                    pageDots: config.showDots,
                    groupCells: config.groupCells,
                    adaptiveHeight: config.adaptiveHeight,
                    imagesLoaded: config.imagesLoaded,
                    draggable: !config.notDraggable
                });
            }
        };
        /**
        *  PRIVATE VARIABLES
        */
        this.lastWheelEventTime = 0;
        this.isScrolled = false;
        this.touchStartY = null;
        this.touchEndY = null;
        /**
         *  INIT CAROUSEL
         *
         *  If the container can't contain all the slides then the carousel will be initialized
         *  You must add the attribute data-slide to every slide of the slider
         */
        this.initCarousel = (config) => {
            const createdSlidersArray = [];
            if (window.innerWidth <= config.viewport || !config.viewport) {
                const carouselsList = document.querySelectorAll(config.sliderSelector);
                if (carouselsList && carouselsList.length > 0) {
                    carouselsList.forEach((carousel) => {
                        const sliderItemsList = carousel.querySelectorAll(":scope > [data-slide]");
                        const buttonsContainer = carousel.parentElement.querySelector(":scope > [data-custom-buttons-container]");
                        if (sliderItemsList.length > 1) {
                            //Max number of slides that could exist into the slider
                            const maxNumberOfItems = (carousel.getBoundingClientRect().width) / (sliderItemsList[0].getBoundingClientRect().width);
                            //console.log("numero massimo elementi")
                            //console.log(maxNumberOfItems)
                            //Array of slider's items (How many slide there are on the carousel)
                            const actualSliderItemsNumber = sliderItemsList.length;
                            //console.log("numero reale elementi")
                            //console.log(actualSliderItemsNumber)
                            //If maxNumberOfItems is less than actualSliderItemsNumber then initialize slider carousel or add a class to center item
                            if (actualSliderItemsNumber > maxNumberOfItems) {
                                if (window.innerWidth > config.destroyViewport || !config.destroyViewport) {
                                    // If you want that the card have the same height
                                    if (config.sameCardHeight) {
                                        this.sameCardsHeight(sliderItemsList);
                                    }
                                    // Create Slider
                                    const flickitySlider = this.createCarousel(carousel, config);
                                    // If there is custom buttons
                                    if (buttonsContainer && config.activateCustomButtons) {
                                        this.bindFlickityButtons(buttonsContainer, flickitySlider, config);
                                        if (config.sliderT8) {
                                            this.isSliderT8(sliderItemsList, flickitySlider, buttonsContainer);
                                        }
                                    }
                                    // Counter
                                    this.bindCounter(config, carousel, flickitySlider);
                                    //add created slider to list, in order to return it when the function is called
                                    createdSlidersArray.push(flickitySlider);
                                    // If you want that the card have the same height
                                    if (config.horizontalScrolling) {
                                        window.addEventListener("scroll", () => {
                                            // Check if the carousel is in the viewport
                                            const isInViewport = this.isElementInViewport(carousel);
                                            if (isInViewport) {
                                                if (!this.isScrolled) {
                                                    document.body.style.overflow = "hidden";
                                                    this.scrollHorizontalScrolling(carousel, flickitySlider);
                                                }
                                            }
                                            else {
                                                this.isScrolled = false;
                                            }
                                        });
                                        window.addEventListener("resize", () => {
                                            // Check if the carousel is in the viewport
                                            const isInViewport = this.isElementInViewport(carousel);
                                            if (isInViewport) {
                                                if (!this.isScrolled) {
                                                    document.body.style.overflow = "hidden";
                                                    this.scrollHorizontalScrolling(carousel, flickitySlider);
                                                }
                                            }
                                            else {
                                                this.isScrolled = false;
                                            }
                                        });
                                    }
                                }
                            }
                            else {
                                if (config.activateCustomButtons) {
                                    buttonsContainer.classList.remove("active");
                                }
                                carousel.classList.add("is-not-slider");
                                carousel.setAttribute("data-carousel", "not-active");
                            }
                        }
                    });
                }
            }
            return createdSlidersArray;
        };
    }
    /**
    *  BIND FLICKITY BUTTONS
    *
    *  If there is custom button content, it sets them as slider buttons.
    *  Insert data-button-next and data-button-previous to the elements of the button container.
    */
    bindFlickityButtons(buttonsContainer, flickitySlider, config) {
        if (buttonsContainer && flickitySlider) {
            const buttonNext = buttonsContainer.querySelector("[data-button-next]");
            const buttonPrevious = buttonsContainer.querySelector("[data-button-previous]");
            let clickCount = 1; // Initialize a click count variable
            let previousIndex = flickitySlider.selectedIndex; // Store the previous index
            const counter = buttonsContainer.querySelector("[data-current-slide-index]");
            /**
             * Update the state of the next and previous buttons based on the click count and selected cells
             */
            const updateButtonState = () => {
                //@ts-ignore
                const numClicksToDisable = Math.floor(flickitySlider.cells.length / flickitySlider.selectedCells.length);
                // Disable next button after X clicks or when the last slide is reached
                if (clickCount >= numClicksToDisable || flickitySlider.selectedIndex === flickitySlider.cells.length - 1) {
                    buttonNext.classList.add("disabled");
                }
                else {
                    buttonNext.classList.remove("disabled");
                }
                // Disable previous button at the start of the slider
                if (flickitySlider.selectedIndex === 0) {
                    buttonPrevious.classList.add("disabled");
                }
                else {
                    buttonPrevious.classList.remove("disabled");
                }
            };
            // Handle next button click
            buttonNext.addEventListener("click", (e) => {
                e.preventDefault();
                flickitySlider.next();
                counter.innerHTML = (flickitySlider.selectedIndex + 1).toString();
            });
            // Handle previous button click
            buttonPrevious.addEventListener("click", (e) => {
                e.preventDefault();
                flickitySlider.previous();
                counter.innerHTML = (flickitySlider.selectedIndex + 1).toString();
            });
            // Update button state on initial load
            if (!config.wrapAround) {
                updateButtonState();
            }
            let captureTimeout; // Track the timeout reference
            // Update click count and button state on slide change
            flickitySlider.on('change', () => {
                if (config.captureScreenShot) {
                    clearTimeout(captureTimeout); // Clear previous timeout if any
                }
                if (!config.wrapAround) {
                    const currentIndex = flickitySlider.selectedIndex;
                    if (currentIndex > previousIndex) {
                        clickCount++;
                    }
                    else if (currentIndex < previousIndex) {
                        clickCount--;
                    }
                    previousIndex = currentIndex; // Update the previous index
                    updateButtonState();
                }
                counter.innerHTML = (flickitySlider.selectedIndex + 1).toString();
                if (config.captureScreenShot) {
                    captureTimeout = setTimeout(() => {
                        initTakeScreenshot();
                    }, 3000);
                }
            });
        }
    }
    /**
   *  BIND COUNTER
   *
   *  If there is a slides' counter, this function handles the activation of the current slide corresponding number.
   */
    bindCounter(config, carousel, flickity) {
        if (config.activateCustomCounter) {
            const counter = carousel.parentElement.querySelector("[data-carousel-counter]");
            flickity.on('change', function (index) {
                counter.querySelectorAll("[data-slide-number]").forEach(x => x.classList.remove("active"));
                counter.querySelector(`[data-slide-number="${index + 1}"]`).classList.add("active");
            });
        }
    }
    /**
   *  SAME HEIGHT
   *
   *  If you want that the card have the same height
   */
    sameCardsHeight(sliderItemsList) {
        // Variable to store the highest height
        let maxHeight = 0;
        // Loop through each data-slide element to find the highest height
        for (let i = 0; i < sliderItemsList.length; i++) {
            const slideHeight = sliderItemsList[i].clientHeight - parseInt(getComputedStyle(sliderItemsList[i]).paddingTop) - parseInt(getComputedStyle(sliderItemsList[i]).paddingBottom);
            // Update maxHeight if the current slide's height is greater
            if (slideHeight > maxHeight) {
                maxHeight = slideHeight;
            }
        }
        // Apply the highest height to all data-slide elements
        for (let j = 0; j < sliderItemsList.length; j++) {
            sliderItemsList[j].style.height = maxHeight + 'px';
        }
    }
    /**
     *  SCROLL HORIZONTAL SCROLLING
     *
     *  Scroll the Carousel while scrolling the page
    */
    scrollHorizontalScrolling(carousel, flickity) {
        const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
        if (isMobile) {
            // Handle mobile scrolling behavior
            document.body.addEventListener("touchstart", (event) => {
                const touchStartY = event.touches[0].clientY;
                document.body.addEventListener("touchmove", (event) => {
                    const touchEndY = event.touches[0].clientY;
                    const touchDiff = touchStartY - touchEndY;
                    const scrollThreshold = 5; // Adjust this value to control the scroll sensitivity
                    if (Math.abs(touchDiff) >= scrollThreshold) {
                        if (touchDiff > 0) {
                            if (flickity.selectedIndex === flickity.slides.length - 1) {
                                // Enable page scrolling
                                document.body.style.overflow = "auto";
                                this.isScrolled = true;
                            }
                            else {
                                // Scroll down
                                flickity.next();
                            }
                        }
                        else {
                            if (flickity.selectedIndex === 0) {
                                // Enable page scrolling
                                document.body.style.overflow = "auto";
                                this.isScrolled = true;
                            }
                            else {
                                // Scroll up
                                flickity.previous();
                            }
                        }
                    }
                    else {
                        // Enable page scrolling
                        document.body.style.overflow = "auto";
                        this.isScrolled = true;
                    }
                });
            });
        }
        else {
            carousel.addEventListener("wheel", debouncer((event) => {
                // Check the time since the last wheel event
                const currentTime = new Date().getTime();
                const timeSinceLastEvent = currentTime - this.lastWheelEventTime;
                // If it's been less than 5ms since the last wheel event, ignore this event
                if (timeSinceLastEvent < 5) {
                    return;
                }
                // Set the last wheel event time to the current time
                this.lastWheelEventTime = currentTime;
                const scrollDelta = Math.sign(event.deltaY); // Get the scroll direction (positive or negative)
                if (scrollDelta > 0) {
                    if (flickity.selectedIndex === flickity.slides.length - 1) {
                        // Enable page scrolling
                        document.body.style.overflow = "auto";
                        this.isScrolled = true;
                    }
                    else {
                        // Scroll down
                        flickity.next();
                    }
                }
                else if (scrollDelta < 0) {
                    if (flickity.selectedIndex === 0) {
                        // Enable page scrolling
                        document.body.style.overflow = "auto";
                        this.isScrolled = true;
                    }
                    else {
                        // Scroll up
                        flickity.previous();
                    }
                }
                // Prevent the default behavior of the wheel event
                event.preventDefault();
            }));
        }
    }
    /**
     *  IS ELEMENT IN VIEWPORT
    */
    isElementInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth));
    }
    /**
     *  ONLY FOR HEADING SLIDER T8
    */
    isSliderT8(sliderItemsList, flickity, buttonsContainer) {
        const setHeights = () => {
            sliderItemsList.forEach((sliderItem, index) => {
                const wrapperSliderItem = sliderItem.querySelector(".wrapper");
                if (sliderItem.classList.contains("is-selected")) {
                    // Get the computed styles
                    const wrapperSliderStyles = getComputedStyle(wrapperSliderItem);
                    const buttonContainerStyles = getComputedStyle(buttonsContainer);
                    // Extract values of slide styles
                    const contentHeight = wrapperSliderItem.clientHeight;
                    const marginBottom = parseFloat(wrapperSliderStyles.marginBottom);
                    const paddingBottom = parseFloat(wrapperSliderStyles.paddingBottom);
                    const buttonMarginTop = parseFloat(buttonContainerStyles.marginTop);
                    // Calculate total height of Carousel
                    const totalHeightCarousel = contentHeight + marginBottom;
                    // Set grid of HeadingSliderT8
                    const sliderT8 = document.querySelector("[data-heading-slider-widget].typology-8");
                    sliderT8.style.gridTemplateRows = `1fr ${totalHeightCarousel}px`;
                    // Set height of buttons container
                    buttonsContainer.style.height = `${contentHeight - buttonMarginTop - paddingBottom + 10}px`;
                    const gradientPosition = `${(index / (sliderItemsList.length - 1)) * 100}%`;
                    if (flickity.selectedIndex === 0) {
                        buttonsContainer.style.borderImage = `linear-gradient(to bottom, #FFF 34.62%, rgba(255, 255, 255, 0.20) 34.62%, rgba(255, 255, 255, 0.20) 100%)`;
                        buttonsContainer.style.borderImageSlice = `1`;
                    }
                    else {
                        buttonsContainer.style.borderImage = `linear-gradient(to bottom, #FFF ${gradientPosition}, rgba(255, 255, 255, 0.20) ${gradientPosition}, rgba(255, 255, 255, 0.20) 100%)`;
                        buttonsContainer.style.borderImageSlice = `1`;
                        buttonsContainer.style.borderImageSlice = `1`;
                    }
                }
            });
        };
        setHeights();
        flickity.on('change', () => {
            setHeights();
        });
    }
}
